import { useState, useEffect } from 'react';
import { useToast, Text } from '@chakra-ui/react';
import "./styles.css";

export const OfflineToast = () => {
  const toast = useToast();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);

      if (isOnline) {
        toast.closeAll();
      }
    };

    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);

    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, []);


  if (!isOnline && !toast.isActive('toast')) {
    toast({
      id: 'toast',
      title: <Text fontSize={14}>No internet connection. <br />Some data may be out of date.</Text>,
      status: 'warning',
      duration: null,
      isClosable: true,
      position: 'top',
      colorScheme: 'transparent',
      containerStyle: {
        position: 'absolute',
        top: '80px',
        background: '#f08c34',
        borderRadius: 6,
      },
      onCloseComplete: toast.closeAll,
    });
  }
};